export default __webpack_public_path__ + "static/media/navicon_siphouse_sip.6dc7d17d.svg";